import { COLORS_HEX } from 'libs.react';
export const PALETTE_COLORS = {
    neutral: [{ label: 'Neutral', value: 'neutral', hex: COLORS_HEX.neutral }],
    categorical: [
        { label: 'Red', value: 'red', hex: COLORS_HEX.red },
        { label: 'Dark red', value: 'redDark', hex: COLORS_HEX.redDark },
        { label: 'Orange', value: 'orange', hex: COLORS_HEX.orange },
        { label: 'Dark orange', value: 'orangeDark', hex: COLORS_HEX.orangeDark },
        { label: 'Yellow', value: 'yellow', hex: COLORS_HEX.yellow },
        { label: 'Dark yellow', value: 'yellowDark', hex: COLORS_HEX.yellowDark },
        { label: 'Green', value: 'green', hex: COLORS_HEX.green },
        { label: 'Dark green', value: 'greenDark', hex: COLORS_HEX.greenDark },
        { label: 'Blue', value: 'blue', hex: COLORS_HEX.blue },
        { label: 'Dark blue', value: 'blueDark', hex: COLORS_HEX.blueDark },
        { label: 'Purple', value: 'purple', hex: COLORS_HEX.purple },
        { label: 'Dark purple', value: 'purpleDark', hex: COLORS_HEX.purpleDark },
        { label: 'Neutral', value: 'neutral', hex: COLORS_HEX.neutral },
        { label: 'Light grey', value: 'lightGrey', hex: COLORS_HEX.lightGrey },
        { label: 'Dark grey', value: 'darkGrey', hex: COLORS_HEX.darkGrey },
    ],
    purple: [
        { label: 'Purple 1', value: 'purple1', hex: COLORS_HEX.purple1 },
        { label: 'Purple 2', value: 'purple2', hex: COLORS_HEX.purple2 },
        { label: 'Purple 3', value: 'purple3', hex: COLORS_HEX.purple3 },
        { label: 'Purple 4', value: 'purple4', hex: COLORS_HEX.purple4 },
        { label: 'Purple 5', value: 'purple5', hex: COLORS_HEX.purple5 },
    ],
    greyscale: [
        { label: 'Grey 1', value: 'neutral', hex: COLORS_HEX.neutral },
        { label: 'Grey 2', value: 'lightGrey', hex: COLORS_HEX.lightGrey },
        { label: 'Grey 3', value: 'grey', hex: COLORS_HEX.grey },
        { label: 'Grey 4', value: 'darkGrey', hex: COLORS_HEX.darkGrey },
        { label: 'Grey 5', value: 'black', hex: COLORS_HEX.black },
    ],
};
/**
 * Clears condition `result` when it is not a valid token for the active palette.
 * Keeps chart preview and saved configs aligned when the palette changes or loads stale data.
 */
export const sanitizeConditionalFormatsForPalette = (formats, palette) => {
    if (!formats?.length) {
        return formats;
    }
    const p = palette || 'categorical';
    const allowed = new Set(PALETTE_COLORS[p].map((c) => c.value));
    return formats.map((rule) => ({
        ...rule,
        conditions: rule.conditions.map((cond) => ({
            ...cond,
            result: allowed.has(cond.result) ? cond.result : '',
        })),
    }));
};
